import {RoleModels, AuthConfigReducer} from '@pwbapps/reduxcore'
import _ from 'lodash';
import { InternalRoleActionsType, ExternalRoleActionsType, isExternalApp } from '../../utils/costants';
import { getSelectedProjectId } from '../reducers/project';
import { getProjectRoles } from '../reducers/initialization';
import { getProjectRoleCodes, isInternalSuperAdmin } from '../../models/projectRoles';

export const getSelectedProjectUserRole = (state: any): RoleModels.Role | undefined => {
    const projectId = getSelectedProjectId(state);
    const me = getProjectRoles(state);
    if (!me) return undefined;
    const roles = AuthConfigReducer.getRoles(state);
    if (isInternalSuperAdmin(me)) return roles.find(role => role.name === 'SUPERADMIN');
    const codes = getProjectRoleCodes(me, projectId);
    const selectedRoles = roles.filter(role => codes.some(code => role.name === `${projectId}:${code}`));
    return selectedRoles.length ? { name: codes.join(', '), actions: _.uniq(_.flatMap(selectedRoles, role => role.actions)) } : undefined;
}

export const getSelectedProjectUserActions = (state: any): InternalRoleActionsType[] | ExternalRoleActionsType[] => {
    const userProjectRole = getSelectedProjectUserRole(state);
    if(userProjectRole)
        return (!isExternalApp) ? userProjectRole.actions as InternalRoleActionsType[] : userProjectRole.actions as ExternalRoleActionsType[];
    return [];
}